// assets
import mineAcsIcon from 'assets/images/logo/mineacs-icon.png';

// ==============================|| LOGO ICON ||============================== //

export default function LogoIcon() {
  return (
    <img
      src={mineAcsIcon}
      alt="MineACS"
      style={{ display: 'block', width: 38, height: 38, objectFit: 'contain', objectPosition: 'center' }}
    />
  );
}
